import { Account } from '@120wateraudit/envirio-components/dist/models'
import CrudActions, { ICrudActions } from 'src/actions/helpers/CrudActions'

const actions: ICrudActions = CrudActions<Account>({
  entityName: 'account',
  collectionName: 'accounts'
})

export default actions
